document.addEventListener('DOMContentLoaded', () => {
    const initializedContainers = new Set();

    function isContainerReady(container) {
        const rect = container.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) {
            return false;
        }

        const images = container.querySelectorAll('img');
        if (images.length === 0) return false;

        return Array.from(images).every(img => {
            return img.complete && img.naturalHeight > 0 &&
                (img.classList.contains('lazyloaded') || !img.classList.contains('lazyload'));
        });
    }

    function waitForImagesAndInitialize(container, retryCount = 0) {
        const maxRetries = 30;

        if (isContainerReady(container)) {
            if (!initializedContainers.has(container)) {
                try {
                    $(container).twentytwenty({
                        default_offset_pct: 0.5,
                        orientation: 'horizontal',
                        before_label: 'Before',
                        after_label: 'After',
                        no_overlay: true,
                    });
                    initializedContainers.add(container);

                    setTimeout(() => {
                        if (window.dispatchEvent) {
                            window.dispatchEvent(new Event('resize'));
                        }
                    }, 100);
                } catch (error) {
                    console.warn('Error initializing twentytwenty:', error);
                }
            }
        } else if (retryCount < maxRetries) {
            setTimeout(() => {
                waitForImagesAndInitialize(container, retryCount + 1);
            }, 100);
        } else {
            console.warn('Timeout waiting for container to be ready, initializing anyway');
            if (!initializedContainers.has(container)) {
                try {
                    $(container).twentytwenty({
                        default_offset_pct: 0.5,
                        orientation: 'horizontal',
                        before_label: 'Before',
                        after_label: 'After',
                        no_overlay: true,
                    });
                    initializedContainers.add(container);

                    setTimeout(() => {
                        if (window.dispatchEvent) {
                            window.dispatchEvent(new Event('resize'));
                        }
                    }, 100);
                } catch (error) {
                    console.warn('Error initializing twentytwenty:', error);
                }
            }
        }
    }

    function initializeTwentyTwenty(container = null) {
        if (container) {
            waitForImagesAndInitialize(container);
        } else {
            const containers = document.querySelectorAll('.compare__slide .twentytwenty-container, .twentytwenty-container');
            containers.forEach(container => {
                waitForImagesAndInitialize(container);
            });
        }
    }

    function reinitializeTwentyTwenty(container) {
        if (initializedContainers.has(container)) {
            try {
                const $container = $(container);
                const instance = $container.data('twentytwenty');
                if (instance) {
                    if (typeof instance.destroy === 'function') {
                        instance.destroy();
                    } else if ($container.trigger) {
                        $container.trigger('destroy.twentytwenty');
                    }
                    $container.find('.twentytwenty-handle, .twentytwenty-overlay').remove();
                    $container.find('img').unwrap();
                }
            } catch (error) {
            }
            initializedContainers.delete(container);
        }
        setTimeout(() => {
            waitForImagesAndInitialize(container);
        }, 150);
    }

    function setupImageLoadListeners() {
        document.addEventListener('lazyloaded', (e) => {
            const img = e.target;
            if (img.tagName === 'IMG') {
                const container = img.closest('.twentytwenty-container');
                if (container && !initializedContainers.has(container)) {
                    setTimeout(() => {
                        waitForImagesAndInitialize(container);
                    }, 50);
                } else if (container && initializedContainers.has(container)) {
                    reinitializeTwentyTwenty(container);
                }
            }
        });

        const images = document.querySelectorAll('.twentytwenty-container img');
        images.forEach(img => {
            if (img.complete && img.naturalHeight > 0) {
                const container = img.closest('.twentytwenty-container');
                if (container) {
                    waitForImagesAndInitialize(container);
                }
            } else {
                img.addEventListener('load', () => {
                    const container = img.closest('.twentytwenty-container');
                    if (container) {
                        waitForImagesAndInitialize(container);
                    }
                }, { once: true });
            }
        });
    }

    function initializeSlick() {
        const slideContainer = $('.compare-slide-container');

        if (slideContainer.length === 0) {
            setupImageLoadListeners();
            setTimeout(() => {
                initializeTwentyTwenty();
            }, 100);
            return;
        }

        slideContainer.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            dots: true,
            dotsClass: 'slick-dots custom-dots',
            centerMode: false,
            swipeToSlide: true,
            draggable: false,
            swipe: false,
            prevArrow:
                '<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="40,22 14.828,22 28.828,8 26,5.172 7.172,24 26,42.828 28.828,40 14.828,26 40,26"/></g></svg></button>',
            nextArrow:
                '<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48H0z" fill="none"/><g id="Shopicon"><polygon points="8,26 33.172,26 19.172,40 22,42.828 40.828,24 22,5.172 19.172,8 33.172,22 8,22"/></g></svg></button>',
            customPaging: (slider, i) => {
                const imageBefore = slider.$slides.eq(i).find('img').first().data('src');
                return `<button type="button"><img src="${imageBefore}" alt="Dot image" class="dot-image"/></button>`;
            },
        });

        slideContainer.on('afterChange', (event, slick, currentSlide) => {
            if (currentSlide === 0) {
                $('.slick-prev').attr('disabled', true).addClass('disabled');
            } else {
                $('.slick-prev').attr('disabled', false).removeClass('disabled');
            }

            if (currentSlide === slick.slideCount - 1) {
                $('.slick-next').attr('disabled', true).addClass('disabled');
            } else {
                $('.slick-next').attr('disabled', false).removeClass('disabled');
            }

            const activeSlide = slick.$slides.eq(currentSlide);
            const container = activeSlide.find('.twentytwenty-container')[0];
            if (container) {
                reinitializeTwentyTwenty(container);
            }
        });

        setupImageLoadListeners();

        setTimeout(() => {
            const firstSlide = slideContainer.find('.slick-slide').first();
            const firstContainer = firstSlide.find('.twentytwenty-container')[0];
            if (firstContainer) {
                waitForImagesAndInitialize(firstContainer);
            }
        }, 200);
    }

    setTimeout(initializeSlick, 300);
});